/**
 * The UTC calendar date of `now`, "YYYY-MM-DD": the today every date comparison is made against,
 * on the server and in the web app alike (architecture.md › UTC). East of UTC it is still
 * yesterday for the first hours after local midnight.
 */
export function utcToday(now: Date): string {
  return now.toISOString().slice(0, 10);
}
